<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer022">
<p class="part-number-with-part-title" id="_idParaDest-5" lang="en-US">PART TWO</p>
<p class="part-title-with-part-number" lang="en-US">One Slip</p>
<p class="part-title-with-part-number" lang="en-US"><em class="italic" lang="en-US">Kona, Hawaii 2004</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504082006-5.vue?6bf4b12c